module.exports = __webpack_public_path__ + "./fonts/Panama-Bold.otf";